export var ApiHeaders = /*#__PURE__*/function (ApiHeaders) {
  ApiHeaders["Ctn"] = "X-Ctn";
  ApiHeaders["Auth"] = "X-Auth-Token";
  ApiHeaders["BisToken"] = "X-Bis-Token";
  ApiHeaders["Environment"] = "X-Api-Environment";
  ApiHeaders["AuthScheme"] = "X-Auth-Scheme";
  ApiHeaders["AccessToken"] = "X-Access-Token";
  ApiHeaders["Scheme"] = "X-Scheme";
  ApiHeaders["IsWeb"] = "isWeb";
  ApiHeaders["IdpIdToken"] = "X-IDP-ID-Token";
  ApiHeaders["OsVersion"] = "X-Mobile-OsVersion";
  ApiHeaders["PhoneModel"] = "X-Mobile-PhoneModel";
  ApiHeaders["ConnectionType"] = "X-Mobile-ConnectionType";
  ApiHeaders["Platform"] = "X-Platform";
  ApiHeaders["Source"] = "X-Source";
  return ApiHeaders;
}({});
export var AuthScheme = /*#__PURE__*/function (AuthScheme) {
  AuthScheme["BisToken"] = "BisToken";
  AuthScheme["BisIdToken"] = "BisToken";
  AuthScheme["IdpIdToken"] = "IdpIdToken";
  AuthScheme["Captcha"] = "Captcha";
  return AuthScheme;
}({});
export var authHeader = {
  BisToken: ApiHeaders.BisToken,
  IdpIdToken: ApiHeaders.IdpIdToken,
  Captcha: ApiHeaders.AccessToken
};
export var PREV_ZONE_TYPE_KEY = '__prev_zone_type_key';